module.exports = __webpack_public_path__ + "static/media/2025_Lumina.9ec34d3d.png";